<template>
  <v-container
    id="usuarios-view"
    fluid
    tag="section"
  >
    <v-row align="center">
      <v-col
        cols="12"
        md="3"
      >
        <p class="mb-0 text-h4">
          Solicitudes de Capacitaciones Externas
        </p>
      </v-col>
      <v-col
        cols="12"
        md="9"
      >
        <div class="d-flex justify-end align-center flex-wrap">
          <!-- Grupo de utilidades -->
          <div class="mr-3">
            <a
              :href="'/pdf/maual_cap_ext.pdf'"
              target="_blank"
            >
              <v-btn
                small
                outlined
                color="warning"
                min-width="120"
                class="mr-2"
              >
                <v-icon
                  left
                  small
                >
                  mdi-book-open-variant
                </v-icon>
                Manual de uso
              </v-btn>
            </a>
            <download-excel
              class="v-btn v-btn--outlined v-btn--has-bg theme--light v-size--small success--text mr-2"
              :data="items"
              :fields="json_fields"
              worksheet="CapacitacionesExternas"
              name="capacitacionesExternas.xls"
            >
              <v-icon
                left
                small
                color="success"
              >
                mdi-download
              </v-icon>
              Exportar
            </download-excel>
          </div>
          <!-- Grupo de acciones principales -->
          <div>
            <v-menu
              v-if="userInfo.permits.CREATE_TRAINING || userInfo.permits.CREATE_TRAINING_TERCERO"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  color="primary"
                  min-width="100"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon
                    left
                    small
                  >
                    mdi-plus
                  </v-icon>
                  Generar solicitud
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-if="userInfo.permits.CREATE_TRAINING"
                  @click="addData('N')"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-account</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Individual</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="userInfo.permits.CREATE_TRAINING"
                  @click="addData('S')"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-account-multiple</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Grupal</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="userInfo.permits.CREATE_TRAINING_TERCERO"
                  @click="addData('T')"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-account-arrow-right</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>A nombre <br> de un tercero</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-divider class="mt-6 mb-10 secondary" />
    <material-card
      icon="mdi-filter"
      icon-small
      color="error"
      title="Filtros de informe"
      class="mb-10"
    >
      <v-card-text>
        <v-row align="center">
          <v-col
            cols="4"
          >
            <v-menu
              v-model="displayDate"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="filter.range"
                  label="Seleccione un rango de fechas"
                  persistent-hint
                  prepend-icon="mdi-calendar"
                  v-bind="attrs"
                  clearable
                  v-on="on"
                  @blur="loadData()"
                />
              </template>
              <v-date-picker
                v-model="filter.range"
                no-title
                range
                @change="displayDate = false; loadData();"
              />
            </v-menu>
          </v-col>
          <v-col
            cols="3"
          >
            <v-autocomplete
              v-model="filter.user_name"
              :items="lstUsers"
              :loading="isLoading"
              :search-input.sync="searchUsersFilter"
              hide-no-data
              hide-selected
              clearable
              :disabled="!userInfo.permits.SEARCH_USERS_TRAINING"
              item-text="lastname"
              item-value="lastname"
              label="Buscar usuario"
              placeholder="Empieza a escribir para Buscar"
              prepend-icon="mdi-database-search"
              @input="loadData()"
            />
          </v-col>
          <v-col
            cols="3"
          >
            <v-text-field
              v-model="filter.name"
              label="Curso"
              type="text"
              prepend-icon="mdi-filter"
              :disabled="!userInfo.permits.SEARCH_COURSES_TRAINING"
              @blur="loadData()"
            />
          </v-col>
          <v-col
            cols="2"
          >
            <v-text-field
              v-model="filter.group"
              label="Grupo"
              type="text"
              prepend-icon="mdi-magnify"
              :disabled="!userInfo.permits.SEARCH_GROUPS_TRAINING"
              @blur="loadData()"
            />
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col
            cols="3"
          >
            <v-autocomplete
              v-model="filter.area"
              :items="lstAreas"
              :loading="isLoadingAreas"
              :search-input.sync="searchAreas"
              cache-items
              hide-no-data
              hide-selected
              clearable
              item-text="area"
              item-value="area"
              label="Buscar área"
              placeholder="Empieza a escribir para Buscar"
              prepend-icon="mdi-database-search"
              :disabled="!userInfo.permits.SEARCH_AREAS_TRAINING"
              @input="loadData()"
            />
          </v-col>
          <v-col
            cols="3"
          >
            <v-text-field
              v-model="filter.position"
              label="Cargo"
              type="text"
              prepend-icon="mdi-filter"
              :disabled="!userInfo.permits.SEARCH_POSITIONS_TRAINING"
              @blur="loadData()"
            />
          </v-col>
          <v-col
            cols="3"
          >
            <v-autocomplete
              v-model="filter.city"
              :items="lstCities"
              :loading="isLoadingCities"
              :search-input.sync="searchCities"
              cache-items
              hide-no-data
              hide-selected
              clearable
              item-text="city"
              item-value="city"
              label="Buscar ciudad"
              placeholder="Empieza a escribir para Buscar"
              prepend-icon="mdi-database-search"
              :disabled="!userInfo.permits.SEARCH_CITIES_TRAINING"
              @input="loadData()"
            />
          </v-col>
          <v-col
            cols="3"
          >
            <v-select
              v-model="filter.status_id"
              :items="lstStatus"
              label="Estado"
              item-text="name"
              item-value="id"
              prepend-icon="mdi-check-circle"
              clearable
              @change="loadData()"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </material-card>
    <v-row
      v-if="false"
      class="mb-6"
    >
      <v-col
        v-if="userInfo.permits.FEE_AVAILABLE_TRAINING"
        cols="4"
      >
        <material-stat-card
          color="primary"
          icon="mdi-cash-100"
          title="Presupuesto gastado"
          :value="formatPrice(summary.budget_spent)"
          icon-small
        >
          <v-card-text class="mb-0 pb-0">
            <v-divider class="secondary" />&nbsp;
          </v-card-text>
        </material-stat-card>
      </v-col>
      <v-col
        v-if="userInfo.permits.FEE_SPEND_TRAINING"
        cols="4"
      >
        <material-stat-card
          color="primary"
          icon="mdi-currency-usd"
          title="Presupuesto disponible"
          :value="formatPrice(summary.budget_available)"
          icon-small
        >
          <v-card-text class="mb-0 pb-0">
            <v-divider class="secondary" />&nbsp;
          </v-card-text>
        </material-stat-card>
      </v-col>
      <v-col
        v-if="userInfo.permits.APPROVED_TRAINING"
        cols="4"
      >
        <material-stat-card
          color="primary"
          icon="mdi-check-circle"
          title="Capacitaciones por aprobar"
          :value="summary.training_to_approved"
          icon-small
        >
          <v-card-text class="mb-0 pb-0">
            <v-divider class="secondary" />&nbsp;&nbsp;
          </v-card-text>
        </material-stat-card>
      </v-col>
    </v-row>
    <material-card
      icon="mdi-account"
      icon-small
      color="error"
      title="Resumen de solicitudes"
    >
      <v-card-text>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto"
          hide-details
          label="Buscar registros"
          single-line
          style="max-width: 250px;"
        />

        <v-divider class="mt-3" />

        <v-data-table
          :headers="headers"
          :items="items"
          :search.sync="search"
          multi-sort
          must-sort
          :footer-props="{
            showFirstLastPage: true,
            'itemsPerPageText':'Solicitudes por página'
          }"
        >
          <template slot="no-data">
            No hay datos para mostrar
          </template>
          <template slot="no-results">
            No hay resultados para mostrar
          </template>
          <template v-slot:[`item.fee`]="data">
            {{ formatPrice(data.item.fee) }}
          </template>
          <template v-slot:[`item.actions`]="data">
            <div>
              <app-btn
                color="success"
                class="px-2 ml-1"
                elevation="0"
                min-width="0"
                small
                :disabled="!userInfo.permits.VIEW_TRAINING"
                @click="manageData(data.item)"
              >
                <v-icon
                  small
                  v-text="'mdi-eye'"
                />
              </app-btn>
              <app-btn
                color="info"
                class="px-2 ml-1"
                elevation="0"
                min-width="0"
                small
                :disabled="!userInfo.permits.UPDATE_TRAINING"
                @click="editData(data.item)"
              >
                <v-icon
                  small
                  v-text="'mdi-pencil'"
                />
              </app-btn>
              <app-btn
                color="error"
                class="px-2 ml-1"
                elevation="0"
                min-width="0"
                small
                :disabled="!userInfo.permits.DELETE_TRAINING"
                @click="openConfirm(data.item)"
              >
                <v-icon
                  small
                  v-text="'mdi-delete'"
                />
              </app-btn>
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </material-card>
    <v-dialog
      v-model="displayDialog"
      persistent
      max-width="810"
    >
      <material-card
        full-header
        light
        inline
        color="info"
        class="mx-auto solicitud-card"
      >
        <template #heading>
          <div class="text-center pa-5">
            <div class="text-h4 white--text">
              Solicitud de capacitación externa {{ isTercero ? ' tercero' : '' }}
            </div>
          </div>
        </template>
        <v-card-text>
          <v-form>
            <!-- INICIO SOLICITUD GRUPAL -->
            <v-row
              v-if="isTercero"
              align="center"
            >
              <v-col
                cols="12"
              >
                <v-autocomplete
                  v-model="userSelectedTercero"
                  :items="lstUsersTercero"
                  :loading="isLoadingTercero"
                  :search-input.sync="searchUsersTercero"
                  hide-no-data
                  hide-selected
                  clearable
                  item-text="lastname"
                  item-value="id"
                  label="Usuario principal"
                  placeholder="Empieza a escribir para Buscar"
                  prepend-icon="mdi-database-search"
                  return-object
                  class="mb-n3"
                  @change="selectedTercero()"
                />
              </v-col>
            </v-row>
            <!-- INICIO DATOS USUARIO -->
            <v-row align="center">
              <v-col
                cols="4"
              >
                <v-text-field
                  v-model="item.user_name"
                  class="mb-n3"
                  label="Nombres"
                  type="text"
                  :disabled="true"
                />
              </v-col>
              <v-col
                cols="4"
              >
                <v-text-field
                  v-model="item.lastname"
                  class="mb-n3"
                  label="Apellidos"
                  type="text"
                  :disabled="true"
                />
              </v-col>
              <v-col
                cols="4"
              >
                <v-text-field
                  v-model="item.position"
                  class="mb-n3"
                  label="Cargo"
                  type="text"
                  :disabled="true"
                />
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col
                cols="4"
              >
                <v-text-field
                  v-model="item.area"
                  class="mb-n3"
                  label="Área"
                  type="text"
                  :disabled="true"
                />
              </v-col>
              <v-col
                cols="4"
              >
                <v-text-field
                  v-model="item.email"
                  class="mb-n3"
                  label="Email"
                  type="text"
                  :disabled="true"
                />
              </v-col>
              <v-col
                cols="4"
              >
                <v-text-field
                  v-model="item.city"
                  class="mb-n3"
                  label="Ciudad"
                  type="text"
                  :disabled="true"
                />
              </v-col>
            </v-row>
            <!-- FIN DATOS USUARIO -->
            <!-- SWITCH PARA TERCERO GRUPAL -->
            <v-row
              v-if="isTercero"
              align="center"
            >
              <v-col cols="12">
                <v-switch
                  v-model="isTerceroGrupal"
                  label="Agregar más usuarios a esta solicitud"
                  color="primary"
                  hide-details
                  class="mt-0"
                />
              </v-col>
            </v-row>
            <!-- INICIO SOLICITUD GRUPAL -->
            <v-row
              v-if="item.group == 'S' || (isTercero && isTerceroGrupal)"
              align="center"
            >
              <v-col
                cols="5"
              >
                <v-autocomplete
                  v-model="userSelected"
                  :items="lstUsers"
                  :loading="isLoading"
                  :search-input.sync="searchUsers"
                  hide-no-data
                  hide-selected
                  clearable
                  item-text="lastname"
                  item-value="id"
                  :label="isTercero ? 'Agregar más usuarios' : 'Usuarios'"
                  placeholder="Empieza a escribir para Buscar"
                  prepend-icon="mdi-database-search"
                  return-object
                  class="mb-n3"
                />
              </v-col>
              <v-col
                cols="3"
              >
                <v-text-field
                  v-if="userSelected"
                  v-model="userSelected.area"
                  class="mb-n3"
                  label="Área"
                  type="text"
                  :disabled="true"
                />
              </v-col>
              <v-col
                cols="3"
              >
                <v-text-field
                  v-if="userSelected"
                  v-model="userSelected.position"
                  class="mb-n3"
                  label="Cargo"
                  type="text"
                  :disabled="true"
                />
              </v-col>
              <v-col
                cols="1"
              >
                <v-btn
                  v-if="userSelected"
                  class="mb-n3 float-right"
                  min-width="0"
                  icon
                  color="success"
                  @click="addUser()"
                >
                  <v-icon>mdi-plus-circle</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row
              v-if="item.group == 'S' || (isTercero && isTerceroGrupal)"
              align="center"
            >
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="searchUsr"
                  append-icon="mdi-magnify"
                  class="ml-auto"
                  hide-details
                  label="Buscar usuario"
                  single-line
                />

                <v-divider class="mt-3" />

                <v-data-table
                  :headers="headersUsers"
                  :items="item.users"
                  :search.sync="searchUsr"
                  multi-sort
                  must-sort
                  :footer-props="{
                    showFirstLastPage: true,
                    'itemsPerPageText':'Usuarios por página'
                  }"
                >
                  <template slot="no-data">
                    No hay datos para mostrar
                  </template>
                  <template slot="no-results">
                    No hay resultados para mostrar
                  </template>
                  <template v-slot:[`item.actions`]="data">
                    <div>
                      <v-btn
                        class="float-center"
                        min-width="0"
                        icon
                        color="error"
                        @click="removeUser(data.item)"
                      >
                        <v-icon>mdi-minus-circle</v-icon>
                      </v-btn>
                    </div>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>

            <!-- FIN SOLICITUD GRUPAL -->

            <v-row align="center">
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="item.shortname"
                  class="mb-n3"
                  label="Nombre de la capacitación"
                  type="text"
                />
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col
                cols="4"
              >
                <v-select
                  v-model="item.type"
                  :items="lstType"
                  class="mb-n3"
                  label="Tipo"
                  item-text="name"
                  item-value="code"
                />
              </v-col>
              <v-col
                cols="4"
              >
                <v-text-field
                  v-model="item.fee"
                  class="mb-n3"
                  label="Valor solicitado $"
                  type="number"
                  :disabled="item.type != 'P'"
                />
              </v-col>
              <v-col
                cols="4"
              >
                <v-select
                  v-model="item.methodology"
                  :items="lstMethodology"
                  class="mb-n3"
                  label="Metodología"
                  item-text="name"
                  item-value="code"
                />
              </v-col>
            </v-row>
            <!-- FECHAS -->
            <v-row align="center">
              <v-col
                cols="4"
              >
                <v-menu
                  ref="display_start_date"
                  v-model="display_start_date"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="item.start_date"
                      label="Fecha de inicio"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="item.start_date"
                    no-title
                    @input="display_start_date = false"
                  />
                </v-menu>
              </v-col>
              <v-col
                cols="4"
              >
                <v-menu
                  ref="display_end_date"
                  v-model="display_end_date"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="item.end_date"
                      label="Fecha de fin"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="item.end_date"
                    no-title
                    @input="display_end_date = false"
                  />
                </v-menu>
              </v-col>
              <v-col
                cols="4"
              >
                <v-text-field
                  v-model="item.hours"
                  label="Total horas"
                  type="number"
                />
              </v-col>
            </v-row>
            <!-- FIN FECHAS -->
            <v-row align="center">
              <v-col
                cols="4"
              >
                <v-select
                  v-model="item.permission"
                  :items="lstPermission"
                  class="mb-n3"
                  label="¿Requiere permiso de horario?"
                  item-text="name"
                  item-value="code"
                />
              </v-col>
              <v-col
                cols="8"
              >
                <v-text-field
                  v-model="item.schedule"
                  class="mb-n3"
                  label="Describa el horario del permiso"
                  type="text"
                  prepend-icon="mdi-clock"
                  hint="Requiero permiso todos los lunes de 9:00 am a 10:00 am."
                />
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col
                cols="4"
              >
                <v-autocomplete
                  v-model="selectedProvider"
                  :items="lstProviders"
                  :loading="isLoadingProviders"
                  :search-input.sync="searchProviders"
                  hide-no-data
                  clearable
                  :item-text="providerDisplayText"
                  item-value="id"
                  label="Entidad / Proveedor"
                  placeholder="Empieza a escribir para buscar"
                  prepend-icon="mdi-domain"
                  class="mb-n3"
                  return-object
                  @change="onProviderSelected"
                />
              </v-col>
              <v-col
                cols="8"
              >
                <v-file-input
                  v-model="file"
                  label="Adjuntar archivo"
                  class="mb-n3"
                />
              </v-col>
            </v-row>
            <v-row
              align="center"
              class="pt-3 mt-3"
            >
              <v-col
                cols="12"
              >
                <v-textarea
                  v-model="item.comments"
                  label="Comentario"
                  height="60"
                />
              </v-col>
            </v-row>
          </v-form>
          <div class="pa-3 text-center mt-2">
            <v-btn
              small
              color="error"
              min-width="100"
              @click="closeDialog()"
            >
              Cancelar
            </v-btn>
            <v-btn
              small
              color="success"
              class="ml-2"
              min-width="100"
              @click="store()"
            >
              Guardar
            </v-btn>
          </div>
        </v-card-text>
      </material-card>
    </v-dialog>
    <v-overlay
      class="v-overlay-custom"
      :value="overlay"
    >
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <material-snackbar
      v-model="snackbar.display"
      :type="snackbar.type"
      timeout="10000"
      v-bind="{
        ['top']: true,
        ['right']: true
      }"
    >
      <div>
        <span class="font-weight-bold">&nbsp;{{ snackbar.title }}&nbsp;</span> <span v-html="snackbar.message" />
      </div>
    </material-snackbar>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar
          extended
          dark
          color="primary"
          extension-height="10"
        >
          <v-btn
            icon
            dark
            @click="closeManageData()"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-toolbar-title>Gestión de Capacitación Externa</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="bg-gray">
          <default-capacitacion-externa
            v-if="dialog"
            :id="item.id"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- DIALOGO DE CONFIRMACIÓN -->
    <v-dialog
      v-model="confirm"
      persistent
      max-width="350"
    >
      <v-card>
        <v-card-title class="text-h4">
          Confirmación
        </v-card-title>
        <v-card-text>
          <span class="text-h5">
            ¿Esta seguro de eliminar la solicitud?
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="warning"
            small
            @click="confirm = false"
          >
            No
          </v-btn>
          <v-btn
            color="success"
            small
            @click="deleteData()"
          >
            Si
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import TrainingRequestService from '../services/TrainingRequestService';
  import UserService from '../services/UserService';
  import ParameterService from '../services/ParameterService';
  import TrainingProviderService from '../services/TrainingProviderService';
  import { getErrorMessage } from '@/util/helpers';
  import { get } from 'vuex-pathify';
  export default {
    name: 'CapacitacionesExternasView',
    components: {
      DefaultCapacitacionExterna: () => import('../components/generic/CapacitacionExterna'), /* webpackChunkName: "default-drawer-toggle" */
    },
    data: () => ({
      headers: [
        {
          text: 'ID',
          value: 'id',
        },
        {
          text: 'Fecha',
          value: 'date',
        },
        {
          text: 'Área',
          value: 'area',
        },
        {
          text: 'Ciudad',
          value: 'city',
        },
        {
          text: 'Usuario',
          value: 'lastname',
        },
        {
          text: 'Cargo',
          value: 'position',
        },
        {
          text: 'Curso',
          value: 'shortname',
        },
        {
          text: 'Costo',
          value: 'fee',
        },
        {
          text: 'Horas',
          value: 'hours',
        },
        {
          text: 'Estado solicitud',
          value: 'status_name',
        },
        {
          sortable: false,
          text: 'Opciones',
          value: 'actions',
          width: '12%',
          align: 'center',
        },
      ],
      headersUsers: [
        {
          text: 'Usuario',
          value: 'lastname',
        },
        {
          text: 'Área',
          value: 'area',
        },
        {
          sortable: false,
          text: 'Eliminar',
          value: 'actions',
          width: '10%',
          align: 'center',
        },
      ],
      filter: {
        range: null,
        user_id: null,
        user_name: null,
        user: null,
        name: null,
        group: null,
        area: null,
        position: null,
        city: null,
        status_id: null,
        role_id: null,
      },
      summary: {
        budget_spent: null,
        budget_available: null,
        training_to_approved: null,
      },
      lstStatus: [],
      items: [],
      item: {
        id: null,
        user_id: null,
        user_name: null,
        lastname: null,
        position: null,
        category: null,
        area: null,
        email: null,
        city: null,
        type: null,
        shortname: null,
        start_date: null,
        hours: null,
        end_date: null,
        fee: null,
        permission: null,
        schedule: null,
        methodology: null,
        institute: null,
        training_provider_id: null,
        group: 'N',
        users: [],
      },
      file: null,
      displayDate: false,
      display_start_date: false,
      display_end_date: false,
      dialog: false,
      lstType: [
        { code: 'G', name: 'Gratis' },
        { code: 'P', name: 'Pago' },
      ],
      lstPermission: [
        { code: 'S', name: 'Si' },
        { code: 'N', name: 'No' },
      ],
      lstMethodology: [
        { code: 'P', name: 'Presencial' },
        { code: 'V', name: 'Virtual' },
      ],
      trainingRequestService: null,
      parameterService: null,
      userService: null,
      trainingProviderService: null,
      search: undefined,
      searchUsr: undefined,
      overlay: false,
      displayDialog: false,
      disabled: false,
      isEdit: false,
      confirm: false,
      snackbar: {
        display: false,
        title: null,
        type: 'success',
        message: null,
      },
      json_fields: {
        ID: 'id',
        Fecha: 'date',
        Área: 'area',
        Ciudad: 'city',
        Usuario: 'lastname',
        Cargo: 'position',
        Curso: 'shortname',
        Costo: 'fee',
        Horas: 'hours',
        'Estado solicitud': 'status_name',
      },
      // para el filtro de usuario
      userSelected: {},
      lstUsers: [],
      isLoading: false,
      searchUsers: null,
      searchUsersTercero: null,
      lstUsersTercero: [],
      isLoadingTercero: false,
      userSelectedTercero: {},
      searchUsersFilter: null,
      // filtro por cursos
      isLoadingCourses: false,
      lstCourses: [],
      searchCourses: null,
      // filtro por ciudades
      isLoadingCities: false,
      lstCities: [],
      searchCities: null,
      // filtro por areas
      isLoadingAreas: false,
      lstAreas: [],
      searchAreas: null,
      // CAPACITACIÓN PARA TERCERO
      isTercero: false,
      isTerceroGrupal: false,
      // filtro por proveedores
      isLoadingProviders: false,
      lstProviders: [],
      searchProviders: null,
      selectedProvider: null,
    }),
    computed: {
      ...get('session', [
        'userInfo',
      ]),
    },
    watch: {
      searchUsers (val) {
        this.isLoading = true;
        this.parameterService.filterUsers(val).then(res => {
          const { count, entries } = res;
          this.count = count;
          this.lstUsers = entries;
          this.isLoading = false;
        }).catch((error) => {
          console.log('Error::::::', error);
          this.isLoading = false;
        });
      },
      searchUsersTercero (val) {
        this.isLoadingTercero = true;
        this.parameterService.filterUsers(val).then(res => {
          const { count, entries } = res;
          this.lstUsersTercero = entries;
          this.isLoadingTercero = false;
        }).catch((error) => {
          console.log('Error::::::', error);
          this.isLoadingTercero = false;
        });
      },
      searchUsersFilter (val) {
        this.isLoading = true;
        this.parameterService.filterUsers(val).then(res => {
          const { count, entries } = res;
          this.count = count;
          this.lstUsers = entries;
          this.isLoading = false;
        }).catch((error) => {
          console.log('Error::::::', error);
          this.isLoading = false;
        });
      },
      searchCourses (val) {
        this.isLoadingCourses = true;
        this.trainingRequestService.filter(val).then(res => {
          const { count, entries } = res;
          this.count = count;
          this.lstCourses = entries;
          this.isLoadingCourses = false;
        }).catch((error) => {
          console.log('Error::::::', error);
          this.isLoadingCourses = false;
        });
      },
      searchCities (val) {
        this.isLoadingCities = true;
        this.parameterService.filterCities(val).then(res => {
          const { count, entries } = res;
          this.count = count;
          this.lstCities = entries;
          this.isLoadingCities = false;
        }).catch((error) => {
          console.log('Error::::::', error);
          this.isLoadingCities = false;
        });
      },
      searchAreas (val) {
        this.isLoadingAreas = true;
        this.parameterService.filterAreas(val).then(res => {
          const { count, entries } = res;
          this.count = count;
          this.lstAreas = entries;
          this.isLoadingAreas = false;
        }).catch((error) => {
          console.log('Error::::::', error);
          this.isLoadingAreas = false;
        });
      },
      searchProviders (val) {
        if (!val || val.length < 2) return;
        this.isLoadingProviders = true;
        this.trainingProviderService.search(val).then(res => {
          this.lstProviders = res.data;
          this.isLoadingProviders = false;
        }).catch((error) => {
          console.log('Error::::::', error);
          this.isLoadingProviders = false;
        });
      },
    },
    created () {
      this.trainingRequestService = new TrainingRequestService();
      this.userService = new UserService();
      this.parameterService = new ParameterService();
      this.trainingProviderService = new TrainingProviderService();
    },
    mounted () {
      this.loadData();
      this.loadParameters();
    },
    methods: {
      providerDisplayText (item) {
        if (item.business_name) {
          return `${item.name} - ${item.business_name}`;
        }
        return item.name;
      },
      loadData () {
        this.overlay = true;
        this.filter.user_id = this.userInfo.id;
        console.log(this.filter);
        this.trainingRequestService.getAllByFilter(this.filter).then(response => {
          this.items = response.data.data;
          this.summary = response.data.summary;
          this.overlay = false;
        }).catch((error) => {
          console.log(error);
          this.overlay = false;
        });
      },
      loadParameters () {
        this.overlay = true;
        this.parameterService.getByType(1).then(response => {
          this.lstStatus = response.data;
          this.overlay = false;
        }).catch((error) => {
          console.log(error);
          this.overlay = false;
        });
      },
      addData (group) {
        this.item = {};
        this.selectedProvider = null; // Limpiar proveedor seleccionado
        this.overlay = true;
        // VALIDAR SI NO ES A NOMBRE PROPIO
        this.isTercero = group === 'T';
        if (!this.isTercero) {
          this.item.user_id = this.userInfo.id;
          this.item.user_name = this.userInfo.name;
          this.item.lastname = this.userInfo.lastname;
          this.item.position = this.userInfo.position;
          this.item.area = this.userInfo.area;
          this.item.email = this.userInfo.email;
          this.item.city = this.userInfo.city;
        }
        this.item.status_id = 1;
        this.item.group = group === 'S' ? group : 'N';
        if (group === 'S' || group === 'T') {
          this.item = {
            ...this.item,
            users: [],
          };
        } else {
          this.item = {
            ...this.item,
            users: null,
          };
        }
        this.displayDialog = true;
        this.overlay = false;
        this.isEdit = false;
      },
      async editData (item) {
        this.overlay = true;
        this.isEdit = true;
        this.item = Object.assign({}, item);

        // Cargar el proveedor seleccionado si existe
        if (this.item.training_provider_id) {
          // Buscar el proveedor en la lista actual
          let provider = this.lstProviders.find(p => p.id === this.item.training_provider_id);

          if (!provider) {
            // Si no está en la lista, obtenerlo del backend
            try {
              const response = await this.trainingProviderService.all();
              provider = response.data.find(p => p.id === this.item.training_provider_id);
              if (provider) {
                // Agregar a la lista si no está
                const exists = this.lstProviders.find(p => p.id === provider.id);
                if (!exists) {
                  this.lstProviders.push(provider);
                }
              }
            } catch (error) {
              console.error('Error loading provider:', error);
            }
          }

          this.selectedProvider = provider || null;
        } else {
          this.selectedProvider = null;
        }

        this.overlay = false;
        this.displayDialog = true;
      },
      openConfirm (item) {
        this.item = Object.assign({}, item);
        this.confirm = true;
      },
      store () {
        // VALIDAR QUE SE AGREGE LOS USUARIOS
        if (this.item.group === 'S' && this.item.users.length === 0) {
          this.snackbar = {
            display: true,
            title: 'ERROR: ',
            type: 'error',
            message: 'No ha seleccionado ningún usuario para la capacitación.',
          };
          return false;
        }

        // Si es tercero grupal y tiene usuarios adicionales, enviar como grupal
        if (this.isTercero && this.isTerceroGrupal && this.item.users && this.item.users.length > 0) {
          this.item.group = 'S';
        }
        // Si el switch está apagado, limpiar usuarios
        if (this.isTercero && !this.isTerceroGrupal) {
          this.item.users = [];
        }

        if (!this.isEdit) this.saveData();
        else this.updateData();
      },
      saveData () {
        // GUARDAR SOLICTUD
        this.overlay = true;
        const model = Object.assign({}, this.item);
        const formData = new FormData();
        formData.append('data', JSON.stringify(this.item));
        formData.append('file', this.file);
        this.trainingRequestService.create(formData).then(response => {
          this.overlay = false;
          this.item = {};
          this.displayDialog = false;
          this.loadData();
          this.snackbar = {
            display: true,
            title: 'INFO: ',
            type: 'success',
            message: response.message,
          };
        }).catch((error) => {
          this.overlay = false;
          this.item = model;
          this.snackbar = {
            display: true,
            title: 'ERROR: ',
            type: 'error',
            message: getErrorMessage(error.response.data.message),
          };
          this.displayDialog = true;
        });
      },
      updateData () {
        // ACTUALIZAR SOLICTUD
        this.overlay = true;
        const model = Object.assign({}, this.item);
        const formData = new FormData();
        formData.append('data', JSON.stringify(this.item));
        formData.append('file', this.file);
        formData.append('_method', 'PUT');
        this.trainingRequestService.update(formData, this.item.id).then(response => {
          this.overlay = false;
          this.displayDialog = false;
          this.file = null;
          this.loadData();
          this.snackbar = {
            display: true,
            title: 'INFO: ',
            type: 'success',
            message: response.message,
          };
        }).catch((error) => {
          console.log(error);
          this.item = model;
          this.overlay = false;
          this.snackbar = {
            display: true,
            title: 'ERROR: ',
            type: 'error',
            message: getErrorMessage(error.response.data.message),
          };
        });
      },
      deleteData () {
        // UPDATE
        this.overlay = true;
        this.trainingRequestService.delete(this.item.id).then(response => {
          this.overlay = false;
          this.item = {};
          this.confirm = false;
          this.loadData();
          this.snackbar = {
            display: true,
            title: 'INFO: ',
            type: 'success',
            message: response.message,
          };
        }).catch((error) => {
          this.confirm = false;
          this.overlay = false;
          this.snackbar = {
            display: true,
            title: 'ERROR: ',
            type: 'error',
            message: getErrorMessage(error.response.data.message),
          };
        });
      },
      manageData (item) {
        this.item = Object.assign({}, item);
        this.dialog = true;
      },
      closeDialog () {
        this.item = {};
        this.selectedProvider = null;
        this.userSelectedTercero = {};
        this.isTerceroGrupal = false;
        this.disabled = true;
        this.displayDialog = false;
        this.overlay = false;
      },
      closeManageData () {
        this.item = {};
        this.dialog = false;
        this.loadData();
      },
      addUser () {
        if (this.userSelected != null) {
          const found = this.item.users.find(usr => usr.id === this.userSelected.id);
          if (found === undefined) this.item.users.push(this.userSelected);
          else {
            this.snackbar = {
              display: true,
              title: 'ERROR: ',
              type: 'error',
              message: 'El usuario ya se ecnuentra asignado',
            };
          }
          this.userSelected = {};
        }
      },
      removeUser (item) {
        const index = this.item.users.findIndex((element) => element.id === item.id);
        console.log('removeUser:::::::', index);
        this.item.users.splice(index, 1);
      },
      formatPrice (value) {
        let val = 0;
        val = (value / 1).toFixed(0).replace('.', ',');
        return '$ ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      },
      onProviderSelected () {
        if (this.selectedProvider) {
          this.item.training_provider_id = this.selectedProvider.id;
          this.item.institute = this.selectedProvider.name;
        } else {
          this.item.training_provider_id = null;
          this.item.institute = null;
        }
      },
      selectedTercero () {
        if (this.userSelectedTercero && this.userSelectedTercero.id) {
          this.item.user_id = this.userSelectedTercero.id;
          this.item.user_name = this.userSelectedTercero.name;
          this.item.lastname = this.userSelectedTercero.lastname;
          this.item.position = this.userSelectedTercero.position;
          this.item.area = this.userSelectedTercero.area;
          this.item.email = this.userSelectedTercero.email;
          this.item.city = this.userSelectedTercero.city;
        } else {
          this.item.user_id = null;
          this.item.user_name = null;
          this.item.lastname = null;
          this.item.position = null;
          this.item.area = null;
          this.item.email = null;
          this.item.city = null;
          this.userSelectedTercero = {};
        }
        this.loadData();
      },
    },

  };
</script>

<style scoped>
.solicitud-card ::v-deep .v-card__text {
  color: rgba(0, 0, 0, 1);
}

.solicitud-card ::v-deep .v-input {
  color: rgba(0, 0, 0, 1);
}

.solicitud-card ::v-deep .v-input--is-disabled {
  opacity: 1;
}

.solicitud-card ::v-deep .v-input input,
.solicitud-card ::v-deep .v-input textarea,
.solicitud-card ::v-deep .v-select__selection {
  color: rgba(0, 0, 0, 1) !important;
}

.solicitud-card ::v-deep .v-label {
  color: rgba(0, 0, 0, 0.7) !important;
}

.solicitud-card ::v-deep .v-icon {
  color: rgba(0, 0, 0, 0.7) !important;
}

.solicitud-card ::v-deep .v-data-table th,
.solicitud-card ::v-deep .v-data-table td,
.solicitud-card ::v-deep .v-data-footer {
  color: rgba(0, 0, 0, 1) !important;
}
</style>
